import { Transition, Menu } from "@headlessui/react";
import React, { useContext } from "react";
import SlideOverContext from "../../../context/SliderOverContext";
import Item from "./SlideOverListItem";
import { Employee } from "../../../types";

interface Props {
  data: Array<Employee>;
  children: React.ReactNode;
};

const List = ({ data = [], children }: Props) => {
  const { open, toggle } = useContext(SlideOverContext);

  return (
    <Transition show={open}>
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <section className="absolute inset-y-0 right-0 pl-10 max-w-full flex sm:pl-16">
            <Transition.Child
              className="w-screen max-w-md"
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="h-full flex flex-col bg-white shadow-xl overflow-y-scroll">
                <header className="p-6">
                  <div className="flex items-start justify-between space-x-3">
                    <h2 className="text-lg leading-7 font-medium text-gray-900">
                      {children}
                    </h2>
                    <div className="h-7 flex items-center">
                      <button
                        aria-label="Close panel"
                        className="text-gray-400 hover:text-gray-500 transition ease-in-out duration-150"
                        onClick={toggle}
                      >
                        <svg
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </header>
                {/* <div className="border-b border-gray-200">
                  <div className="px-6">
                    <nav className="-mb-px flex space-x-6">
                      <button
                        className="whitespace-no-wrap pb-4 px-1 border-b-2 border-orange-500 font-medium text-sm leading-5 text-orange-600 focus:outline-none focus:text-orange-800 focus:border-orange-700"
                        aria-current="page"
                      >
                        Alle
                      </button>

                      <button className="whitespace-no-wrap pb-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300">
                        Aktiv
                      </button>

                      <button className="whitespace-no-wrap pb-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300">
                        Inaktiv
                      </button>
                    </nav>
                  </div>
                </div> */}
                <ul className="divide-y divide-gray-200 overflow-y-auto">
                  {data.map((employee: Employee) => (
                    <Item key={employee._id} employee={employee} />
                  ))}
                </ul>
              </div>
            </Transition.Child>
          </section>
        </div>
      </div>
    </Transition>
  );
};

export default List;
